"use client";
import { Collapse, Typography } from "antd/lib";
import Heading from "@/app/components/Heading";
import MyCard from "@/app/components/MyCard";
import type { IPriceFAQForecast } from "@/app/components/products/ProductForecast/index";
import useAxiosQuery from "@/hooks/useMyQuery";

const ForecastFAQ = ({ symbol }: { symbol: string }) => {
  const { data: response } = useAxiosQuery<{ data?: IPriceFAQForecast[] }>({
    url: "v1/product/forecast/faq",
    params: {
      symbol,
    },
  });

  const data: IPriceFAQForecast[] = response?.data ? response.data : [];
  const { Panel } = Collapse;

  return (
    <MyCard className="h-full" title={<Heading title={symbol + " Price Forecast FAQ"} />}>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
        {data.map((item, index) => (
          <Collapse 
            className="collapse-wrapper"
            key={index.toString()}
            style={{ alignSelf: 'flex-start' }}
          >
            <Panel 
              header={<h3>{item.question}</h3>} 
              key={index.toString()}
              style={{ height: 'auto' }}
            >
              <Typography.Text type="secondary">{item.answer}</Typography.Text>
            </Panel>
          </Collapse>
        ))}
      </div>
    </MyCard>
  );
};

export default ForecastFAQ;
